export function getAddOnTrialDaysRemaining(trialEndDateString) {
  if (!trialEndDateString) {
    return false;
  }

  const DAYS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
  const now = new Date();
  const trialEndDate = new Date(trialEndDateString);

  const isTrialOver = now.getTime() > trialEndDate.getTime();

  return isTrialOver
    ? false
    : Math.ceil(
        (trialEndDate.getTime() - now.getTime()) / DAYS_IN_MILLISECONDS
      );
}
